<div nxLayout="grid maxwidth" class="inbox">
    <div nxRow>
        <div nxCol="12" class="section-title">
            <h3 nxHeadline="subsection-large" translate>inbox.email-us.basic.section-title</h3>
            <nx-link>
                <a [routerLink]="['']">
                    <nx-icon [name]="'chevron-left'"></nx-icon>
                    {{ "inbox.email-us.result.btnText" | translate }}
                </a>
            </nx-link>
        </div>

        <div nxCol="12" class="email-us-card">
            <div nxRow class="email-us-card-header" nxRowAlignItems="center">
                <div nxCol="3" class="new-msg">
                    <cpc-button disabled="true" size="x-small" [noHorizontalMargin]="true" [noVerticalMargin]="true">
                        <span translate>inbox.email-us.basic.new-message</span>
                    </cpc-button>
                </div>
                <div nxCol="8">
                    <h4 nxHeadline="subsection-small" *ngIf="this.subject!=null">
                        <small nxHeadline="subsection-xsmall" class="nx-font-weight-light">{{
              "inbox.email-us.basic.subject" | translate }} </small><span>{{ this.subject | translate }}</span> <span
                            class="ml-05" *ngIf="selectedPolicy">{{ selectedPolicy.policyNumber }}</span>
                    </h4>
                    <h4 nxHeadline="subsection-small" *ngIf="this.subject==null">{{ "inbox.email-us.basic.new-message" |
            translate }}</h4>
                </div>
                <div nxCol="1" *ngIf="!this.formBEValid" class="last">
                    <span *ngIf="!isInReply">
                        <cpc-icon icon="close" (click)="changeRoute()"
                            style="font-size: 24px; cursor: pointer;"></cpc-icon>
                    </span>
                    <span *ngIf="isInReply">
                        <button nxPlainButton type="button" (click)="editTopic()" class="file-a-claim">
                            {{ "inbox.email-us.basic.edit" | translate }}<nx-icon name="edit"
                                class="nx-margin-left-2xs"></nx-icon>
                        </button>
                    </span>
                </div>
            </div>

            <div nxRow>
                <div nxCol="12,12,3" class="side-nav">
                    <cpc-side-nav>
                        <cpc-nav-item *ngFor="let navLink of navList;first as isFirst" [icon]="navLink.icon"
                            [disabled]="!navLink.active" (click)="changeRoute($event, navLink.component)">
                            {{navLink.buttonText | translate}}
                        </cpc-nav-item>
                    </cpc-side-nav>
                </div>
                <div nxCol="12,12,9">
                    <div nxRow>
                        <div nxCol="12" class="messages">
                            <form [formGroup]="form" (submit)="submit($event)">
                                <cpc-message-preview>
                                    <div class="messages-result" *ngIf="this.formBEValid">
                                        <div class="content">
                                            <cpc-illustration name="confirmationLetter" width="140px">
                                            </cpc-illustration>
                                            <h3 nxHeadline="subsection-large">{{ "inbox.email-us.result.title" |
                        translate }}</h3>
                                            <p>
                                                {{ "inbox.email-us.result.text" | translate }}
                                            </p>
                                            <a>
                                                <cpc-button (click)="reload()" size="x-small">{{ "inbox.email-us.result.btnText" |
                          translate }}
                                                </cpc-button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="messages-content" *ngIf="!isInReply&&!this.formBEValid">
                                        <div nxRow>
                                            <div nxCol="12">
                                                <h3 nxHeadline="subsection-large">{{
                          "inbox.email-us.basic.choose-subject" | translate }}</h3>
                                            </div>
                                        </div>
                                        <div nxRow>
                                            <div nxCol="12,12,12,6">
                                                <nx-formfield
                                                    label=" {{ 'inbox.email-us.basic.topicLabel' | translate }}">
                                                    <nx-dropdown formControlName="firstLevelTopic"
                                                        (ngModelChange)="firstLevelBind()">
                                                        <ng-template ngFor let-firstLevel="$implicit"
                                                            [ngForOf]="EmailUsTopics.firstLevel|keyvalue">
                                                            <nx-dropdown-item value="{{ firstLevel.value.secondId }}">
                                                                {{ firstLevel.value.name|translate }}
                                                            </nx-dropdown-item>
                                                        </ng-template>
                                                    </nx-dropdown>
                                                </nx-formfield>
                                            </div>
                                        </div>

                                        <div nxRow *ngIf="!allowSelectedSubjectAndPolicies()">
                                            <div nxCol="12">
                                                <nx-radio-group formControlName="secondLevelTopic"
                                                    (groupValueChange)="secondLevelBind($event.value)"
                                                    [required]="true">
                                                    <ng-template ngFor let-secondLevel="$implicit"
                                                        [ngForOf]="firstLevelBind()">
                                                        <nx-radio class="nx-margin-bottom-m"
                                                            value="{{ secondLevel.key }}">{{ secondLevel.name | translate }}</nx-radio>
                                                    </ng-template>
                                                </nx-radio-group>
                                            </div>
                                        </div>

                                        <div nxRow nxRowAlignItems="center" *ngIf="allowSelectedSubjectAndPolicies()">
                                            <div nxCol="12,12,12,6">
                                                <nx-formfield label="{{ 'inbox.email-us.basic.subject' | translate }}">
                                                    <input type="text" formControlName="selectedSubject"
                                                        ngModel="{{ subject | translate }}" nxInput readonly>
                                                </nx-formfield>
                                                <button nxPlainButton type="button" (click)="editSubject()"
                                                    class="btn--edit-subject">
                                                    <nx-icon [name]="'edit'"></nx-icon>
                                                </button>
                                            </div>
                                        </div>


                                        <div nxRow *ngIf="allowSelectedSubjectAndPolicies()">
                                            <div nxCol="12">
                                                <nx-radio-group formControlName="policy"
                                                    (groupValueChange)="policyBind($event.value)">
                                                    <ng-template ngFor let-policy="$implicit"
                                                        [ngForOf]="policies|keyvalue">
                                                        <nx-radio class="nx-margin-bottom-m" value="{{ policy.key }}">
                                                            <div class="radio-with-icon">
                                                                <div>
                                                                    <cpc-icon left
                                                                        [icon]="getGroupByLobId(policy.value.lineOfBusinessId).icon"
                                                                        color="#006192" borderStyle="circle"
                                                                        backgroundColor="#fff"></cpc-icon>
                                                                    <span>{{ policy.value.policyNumber }}</span>
                                                                </div>
                                                                <div class="policy-detail"
                                                                    id="{{ policy.value.policyNumber }}">
                                                                    <span>
                                                                        {{'active-insurance-group.' + getGroupByLobId(policy.value.lineOfBusinessId).name | translate}}
                                                                        <div
                                                                            [ngSwitch]="LOB.setId(policy.value.lineOfBusinessId).lob">
                                                                            <b *ngSwitchCase="lob.CarInsurance">{{policy.value.model | stringFormat}}&nbsp;-
                                                                                {{policy.crn | stringFormat}}</b>
                                                                            <b
                                                                                *ngSwitchCase="lob.LifeInsurance">{{policy.value.firstInsuredName | stringFormat}}</b>
                                                                            <b
                                                                                *ngSwitchCase="lob.HomeInsurance">{{policy.value.householdAddress | stringFormat}}</b>
                                                                        </div>
                                                                        {{ 'home.product-name' | translate }}:
                                                                        <b>{{ policy.value.productNameSpecific }}</b>
                                                                        <br>
                                                                        {{ 'policy.policy-number' | translate }}:
                                                                        <b>{{policy.value.policyNumber}}</b>
                                                                        <br>
                                                                        {{'policy.start-date' | translate}}: <b>
                                                                            {{ policy.value.beginDate | dateFormat }}</b>
                                                                        <br>
                                                                        {{ 'policy.end-date' | translate }}:
                                                                        <b>{{ policy.value.endDate | dateFormat }}</b>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </nx-radio>
                                                    </ng-template>
                                                </nx-radio-group>
                                            </div>
                                        </div>
                                        <div nxRow *ngIf="allowSelectedSubjectAndClaims()">
                                            <div nxCol="12">
                                                <nx-radio-group formControlName="claim"
                                                    (groupValueChange)="claimBind($event.value)">
                                                    <ng-template ngFor let-claim="$implicit"
                                                        [ngForOf]="claims|keyvalue">
                                                        <nx-radio class="nx-margin-bottom-m"
                                                            value="{{ claim.value.claim.claimNumber }}">
                                                            <div class="radio-with-icon">
                                                                <div>
                                                                    <cpc-icon left [icon]="claim.value.icon"
                                                                        color="#006192" borderStyle="circle"
                                                                        backgroundColor="#fff"></cpc-icon>
                                                                    <span>{{ claim.value.claim.claimNumber }}</span>
                                                                </div>
                                                                <div class="policy-detail"
                                                                    id="{{ claim.value.claim.claimNumber }}">
                                                                    <span>
                                                                        {{ 'policy.policy-number' | translate }}:
                                                                        <b>{{claim.value.claim.policyNumber}}</b>
                                                                        <br>
                                                                        {{'claim.event-date' | translate}}:
                                                                        <b>
                                                                            {{ claim.value.claim.eventDate | dateFormat }}</b>
                                                                        <br>
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </nx-radio>
                                                    </ng-template>
                                                </nx-radio-group>
                                            </div>
                                        </div>
                                    </div>

                                    <cpc-message-preview-item *ngIf="!this.formBEValid">
                                        <cpc-message-preview-textarea [isInReply]="isInReply" #messageTextArea
                                            [placeholderMessage]="textData.textAreaPlaceHolder" textarea>
                                        </cpc-message-preview-textarea>
                                    </cpc-message-preview-item>

                                    <span nxFormfieldHint *ngIf="!this.formBEValid">
                                        <span
                                            *ngIf="countMessage > 0">{{ countMessage }} / {{ maxCountMessage }} {{ 'contact-us.email-us.chars' | translate }}</span>
                                    </span>

                                    <cpc-message-preview-footer [isInReply]="isInReply"
                                        [textData]="getTranslatedTextData()" (clickReply)="clickReply()"
                                        (clickAttachment)="clickAttachment()" (clickDelete)="clickDelete()"
                                        (clickSend)="clickSend()" footer *ngIf="!this.formBEValid">
                                    </cpc-message-preview-footer>
                                </cpc-message-preview>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>